webpackJsonp([0],Array(65).concat([
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_main_js__ = __webpack_require__(150);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07366a7c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(205);
function injectStyle (ssrContext) {
  __webpack_require__(185)
}
var normalizeComponent = __webpack_require__(13)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_main_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07366a7c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(88)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(91);
var defined = __webpack_require__(92);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(113);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 92 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(97);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("VueLoading",[],e):"object"==typeof exports?exports.VueLoading=e():t.VueLoading=e()}("undefined"!=typeof self?self:this,function(){return function(t){var e={};function i(n){if(e[n])return e[n].exports;var r=e[n]={i:n,l:!1,exports:{}};return t[n].call(r.exports,r,r.exports,i),r.l=!0,r.exports}return i.m=t,i.c=e,i.d=function(t,e,n){i.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},i.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},i.t=function(t,e){if(1&e&&(t=i(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(i.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)i.d(n,r,function(e){return t[e]}.bind(null,r));return n},i.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return i.d(e,"a",e),e},i.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},i.p="",i(i.s=1)}([function(t,e,i){},function(t,e,i){"use strict";i.r(e);var n="undefined"!=typeof window?window.HTMLElement:Object,r={mounted:function(){document.addEventListener("focusin",this.focusIn)},methods:{focusIn:function(t){if(this.isActive&&t.target!==this.$el&&!this.$el.contains(t.target)){var e=this.container?this.container:this.isFullPage?null:this.$el.parentElement;(this.isFullPage||e&&e.contains(t.target))&&(t.preventDefault(),this.$el.focus())}}},beforeDestroy:function(){document.removeEventListener("focusin",this.focusIn)}};function a(t,e,i,n,r,a,o,s){var u,l="function"==typeof t?t.options:t;if(e&&(l.render=e,l.staticRenderFns=i,l._compiled=!0),n&&(l.functional=!0),a&&(l._scopeId="data-v-"+a),o?(u=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),r&&r.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o)},l._ssrRegister=u):r&&(u=s?function(){r.call(this,this.$root.$options.shadowRoot)}:r),u)if(l.functional){l._injectStyles=u;var c=l.render;l.render=function(t,e){return u.call(e),c(t,e)}}else{var d=l.beforeCreate;l.beforeCreate=d?[].concat(d,u):[u]}return{exports:t,options:l}}var o=a({name:"spinner",props:{color:{type:String,default:"#000"},height:{type:Number,default:64},width:{type:Number,default:64}}},function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{attrs:{viewBox:"0 0 38 38",xmlns:"http://www.w3.org/2000/svg",width:this.width,height:this.height,stroke:this.color}},[e("g",{attrs:{fill:"none","fill-rule":"evenodd"}},[e("g",{attrs:{transform:"translate(1 1)","stroke-width":"2"}},[e("circle",{attrs:{"stroke-opacity":".25",cx:"18",cy:"18",r:"18"}}),this._v(" "),e("path",{attrs:{d:"M36 18c0-9.94-8.06-18-18-18"}},[e("animateTransform",{attrs:{attributeName:"transform",type:"rotate",from:"0 18 18",to:"360 18 18",dur:"0.8s",repeatCount:"indefinite"}})],1)])])])},[],!1,null,null,null);o.options.__file="spinner.vue";var s=o.exports,u=a({name:"dots",props:{color:{type:String,default:"#000"},height:{type:Number,default:240},width:{type:Number,default:60}}},function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("svg",{attrs:{viewBox:"0 0 120 30",xmlns:"http://www.w3.org/2000/svg",fill:t.color,width:t.width,height:t.height}},[i("circle",{attrs:{cx:"15",cy:"15",r:"15"}},[i("animate",{attrs:{attributeName:"r",from:"15",to:"15",begin:"0s",dur:"0.8s",values:"15;9;15",calcMode:"linear",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"fill-opacity",from:"1",to:"1",begin:"0s",dur:"0.8s",values:"1;.5;1",calcMode:"linear",repeatCount:"indefinite"}})]),t._v(" "),i("circle",{attrs:{cx:"60",cy:"15",r:"9","fill-opacity":"0.3"}},[i("animate",{attrs:{attributeName:"r",from:"9",to:"9",begin:"0s",dur:"0.8s",values:"9;15;9",calcMode:"linear",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"fill-opacity",from:"0.5",to:"0.5",begin:"0s",dur:"0.8s",values:".5;1;.5",calcMode:"linear",repeatCount:"indefinite"}})]),t._v(" "),i("circle",{attrs:{cx:"105",cy:"15",r:"15"}},[i("animate",{attrs:{attributeName:"r",from:"15",to:"15",begin:"0s",dur:"0.8s",values:"15;9;15",calcMode:"linear",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"fill-opacity",from:"1",to:"1",begin:"0s",dur:"0.8s",values:"1;.5;1",calcMode:"linear",repeatCount:"indefinite"}})])])},[],!1,null,null,null);u.options.__file="dots.vue";var l=u.exports,c=a({name:"bars",props:{color:{type:String,default:"#000"},height:{type:Number,default:40},width:{type:Number,default:40}}},function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 30 30",height:t.height,width:t.width,fill:t.color}},[i("rect",{attrs:{x:"0",y:"13",width:"4",height:"5"}},[i("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"5;21;5",begin:"0s",dur:"0.6s",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"13; 5; 13",begin:"0s",dur:"0.6s",repeatCount:"indefinite"}})]),t._v(" "),i("rect",{attrs:{x:"10",y:"13",width:"4",height:"5"}},[i("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"5;21;5",begin:"0.15s",dur:"0.6s",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"13; 5; 13",begin:"0.15s",dur:"0.6s",repeatCount:"indefinite"}})]),t._v(" "),i("rect",{attrs:{x:"20",y:"13",width:"4",height:"5"}},[i("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"5;21;5",begin:"0.3s",dur:"0.6s",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"13; 5; 13",begin:"0.3s",dur:"0.6s",repeatCount:"indefinite"}})])])},[],!1,null,null,null);c.options.__file="bars.vue";var d=c.exports,f=a({name:"vue-loading",mixins:[r],props:{active:Boolean,programmatic:Boolean,container:[Object,Function,n],isFullPage:{type:Boolean,default:!0},transition:{type:String,default:"fade"},canCancel:Boolean,onCancel:{type:Function,default:function(){}},color:String,backgroundColor:String,opacity:Number,width:Number,height:Number,loader:{type:String,default:"spinner"}},data:function(){return{isActive:this.active}},components:{Spinner:s,Dots:l,Bars:d},beforeMount:function(){this.programmatic&&(this.container?(this.isFullPage=!1,this.container.appendChild(this.$el)):document.body.appendChild(this.$el))},mounted:function(){this.programmatic&&(this.isActive=!0),document.addEventListener("keyup",this.keyPress)},methods:{cancel:function(){this.canCancel&&this.isActive&&(this.hide(),this.onCancel.apply(null,arguments))},hide:function(){var t=this;this.$emit("hide"),this.$emit("update:active",!1),this.programmatic&&(this.isActive=!1,setTimeout(function(){var e;t.$destroy(),void 0!==(e=t.$el).remove?e.remove():e.parentNode.removeChild(e)},150))},keyPress:function(t){27===t.keyCode&&this.cancel()}},watch:{active:function(t){this.isActive=t}},beforeDestroy:function(){document.removeEventListener("keyup",this.keyPress)}},function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("transition",{attrs:{name:t.transition}},[i("div",{directives:[{name:"show",rawName:"v-show",value:t.isActive,expression:"isActive"}],staticClass:"vld-overlay is-active",class:{"is-full-page":t.isFullPage},attrs:{tabindex:"0","aria-busy":t.isActive,"aria-label":"Loading"}},[i("div",{staticClass:"vld-background",style:{background:this.backgroundColor,opacity:this.opacity},on:{click:function(e){return e.preventDefault(),t.cancel(e)}}}),t._v(" "),i("div",{staticClass:"vld-icon"},[t._t("before"),t._v(" "),t._t("default",[i(t.loader,{tag:"component",attrs:{color:t.color,width:t.width,height:t.height}})]),t._v(" "),t._t("after")],2)])])},[],!1,null,null,null);f.options.__file="Component.vue";var p=f.exports,h=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return{show:function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:e,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:i,a=Object.assign({},e,n,{programmatic:!0}),o=new(t.extend(p))({el:document.createElement("div"),propsData:a}),s=Object.assign({},i,r);return Object.keys(s).map(function(t){o.$slots[t]=s[t]}),o}}};i(0);p.install=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},n=h(t,e,i);t.$loading=n,t.prototype.$loading=n};e.default=p}]).default});

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(125);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(64)("4a1fd46d", content, true, {});

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(98), __esModule: true };

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(99);
module.exports = __webpack_require__(12).Object.assign;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(100);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(110) });


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(85);
var core = __webpack_require__(12);
var ctx = __webpack_require__(101);
var hide = __webpack_require__(103);
var has = __webpack_require__(89);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(102);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(104);
var createDesc = __webpack_require__(109);
module.exports = __webpack_require__(87) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(105);
var IE8_DOM_DEFINE = __webpack_require__(106);
var toPrimitive = __webpack_require__(108);
var dP = Object.defineProperty;

exports.f = __webpack_require__(87) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(86);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(87) && !__webpack_require__(88)(function () {
  return Object.defineProperty(__webpack_require__(107)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(86);
var document = __webpack_require__(85).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(86);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(111);
var gOPS = __webpack_require__(122);
var pIE = __webpack_require__(123);
var toObject = __webpack_require__(124);
var IObject = __webpack_require__(91);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(88)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(112);
var enumBugKeys = __webpack_require__(121);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(89);
var toIObject = __webpack_require__(90);
var arrayIndexOf = __webpack_require__(114)(false);
var IE_PROTO = __webpack_require__(117)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 113 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(90);
var toLength = __webpack_require__(115);
var toAbsoluteIndex = __webpack_require__(116);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(93);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(93);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(118)('keys');
var uid = __webpack_require__(120);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(12);
var global = __webpack_require__(85);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(119) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 120 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 122 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 123 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(92);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(true);
// imports


// module
exports.push([module.i, ".vld-overlay{bottom:0;left:0;position:absolute;right:0;top:0;align-items:center;display:none;justify-content:center;overflow:hidden;z-index:1}.vld-overlay.is-active{display:flex}.vld-overlay.is-full-page{z-index:999;position:fixed}.vld-overlay .vld-background{bottom:0;left:0;position:absolute;right:0;top:0;background:#fff;opacity:.5}.vld-overlay .vld-icon,.vld-parent{position:relative}", "", {"version":3,"sources":["C:/Users/imkeeper/Desktop/Paybox/ui/C9/node_modules/vue-loading-overlay/dist/vue-loading.css"],"names":[],"mappings":"AAAA,aACE,SAAU,AACV,OAAQ,AACR,kBAAmB,AACnB,QAAS,AACT,MAAO,AACP,mBAAoB,AACpB,aAAc,AACd,uBAAwB,AACxB,gBAAiB,AACjB,SAAU,CACX,AAED,uBACE,YAAa,CACd,AAED,0BACE,YAAa,AACb,cAAe,CAChB,AAED,6BACE,SAAU,AACV,OAAQ,AACR,kBAAmB,AACnB,QAAS,AACT,MAAO,AACP,gBAAiB,AACjB,UAAY,CACb,AAMD,mCACE,iBAAkB,CACnB","file":"vue-loading.css","sourcesContent":[".vld-overlay {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  align-items: center;\n  display: none;\n  justify-content: center;\n  overflow: hidden;\n  z-index: 1\n}\n\n.vld-overlay.is-active {\n  display: flex\n}\n\n.vld-overlay.is-full-page {\n  z-index: 999;\n  position: fixed\n}\n\n.vld-overlay .vld-background {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  background: #fff;\n  opacity: 0.5\n}\n\n.vld-overlay .vld-icon {\n  position: relative\n}\n\n.vld-parent {\n  position: relative\n}\n\n\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAQAAAAAYLlVAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADGGlDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjaY2BgnuDo4uTKJMDAUFBUUuQe5BgZERmlwH6egY2BmYGBgYGBITG5uMAxIMCHgYGBIS8/L5UBFTAyMHy7xsDIwMDAcFnX0cXJlYE0wJpcUFTCwMBwgIGBwSgltTiZgYHhCwMDQ3p5SUEJAwNjDAMDg0hSdkEJAwNjAQMDg0h2SJAzAwNjCwMDE09JakUJAwMDg3N+QWVRZnpGiYKhpaWlgmNKflKqQnBlcUlqbrGCZ15yflFBflFiSWoKAwMD1A4GBgYGXpf8EgX3xMw8BSMDVQYqg4jIKAUICxE+CDEESC4tKoMHJQODAIMCgwGDA0MAQyJDPcMChqMMbxjFGV0YSxlXMN5jEmMKYprAdIFZmDmSeSHzGxZLlg6WW6x6rK2s99gs2aaxfWMPZ9/NocTRxfGFM5HzApcj1xZuTe4FPFI8U3mFeCfxCfNN45fhXyygI7BD0FXwilCq0A/hXhEVkb2i4aJfxCaJG4lfkaiQlJM8JpUvLS19QqZMVl32llyfvIv8H4WtioVKekpvldeqFKiaqP5UO6jepRGqqaT5QeuA9iSdVF0rPUG9V/pHDBYY1hrFGNuayJsym740u2C+02KJ5QSrOutcmzjbQDtXe2sHY0cdJzVnJRcFV3k3BXdlD3VPXS8Tbxsfd99gvwT//ID6wIlBS4N3hVwMfRnOFCEXaRUVEV0RMzN2T9yDBLZE3aSw5IaUNak30zkyLDIzs+ZmX8xlz7PPryjYVPiuWLskq3RV2ZsK/cqSql01jLVedVPrHzbqNdU0n22VaytsP9op3VXUfbpXta+x/+5Em0mzJ/+dGj/t8AyNmf2zvs9JmHt6vvmCpYtEFrcu+bYsc/m9lSGrTq9xWbtvveWGbZtMNm/ZarJt+w6rnft3u+45uy9s/4ODOYd+Hmk/Jn58xUnrU+fOJJ/9dX7SRe1LR68kXv13fc5Nm1t379TfU75/4mHeY7En+59lvhB5efB1/lv5dxc+NH0y/fzq64Lv4T8Ffp360/rP8f9/AA0ADzT6lvFdAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAADGSURBVHja7NmxDoMwDITh2Or7v7I7VAhoY8jS+weOiQHpPgUHOyJqsFcOAwwwwAAD4Ou18MzeLoJYgWruRYBia6DYIix2F8zihUUoiu8Asvg5QBg/A0jjfwHi+G+APP4MAOKPACR+B0DxGwCL/wDA+DGi4NOpZ0IDcEAUvA2zCSvtKwAJebHk4qkYIuRN4YlPRgAhF7ZfKQFyQi5+hEoJkBK6XiAj9M1IRLjqhsKpGCTczQNBA86EP3DC/4wMMMAAAx4PeA8A+y4kelHjYKQAAAAASUVORK5CYII="

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/scan.55d8994.gif";

/***/ }),
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 140 */,
/* 141 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAAW6AAAFugEb7Y3JAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAWhQTFRF////QEhQV2CCPUlNVmCBVF+APUlOVWCAT1p0TVhvVWGAVWCAPElOVWCAVWCAT1lzPElOVWCATVhvPElOPElORFBcQk5ZPElOPElPPUlPPUpQPElOH9SDLopnL4ZlMnlgNmVZN19XPElOPkpPPktQP0xRQE1RQUlOQU5TQ09UQ1BaRFBVRFFWR1NYSEpNSFRZSFViSVVaSlhmS1dcTFdtTVldTlpeTlpyUFxhUV9xUmNbU15jU19jVGBkVWCAVmJmVmR5V15PWWRoWmxgXGdrXW9iXmltX26JY25yZW9zZnB0ZnF0bnh7b3h8cI54cnx/c4hddnZReYGFeoOGfJJlfXtSf4eKgJZohp5ui2Z1jKZzjad+kZibk4xTlE1KlbB7mLN+nrqDn7uEoL2For+Ho8CHpcOJpsSKpsWOp8aLqMaMrMuPrcyQrs2RsM+TsNCUsdGUtbq8x7RWzdHS8vLz9ddY9lJG/f39/VkQQQAAABx0Uk5TACA1P02Oj5ChqK6wuLm9v8DAxMfMz+f4+Pj4/s/oKAQAAAD/SURBVChTY2Bg5JFWQgARZgYYYNNycDBCyAjDJQQM3N0tERLiCAklK1c4cFaS5BYS4+diAUtEFxQUpGYXFCTmpGQoSdmZKJnb8cElwpMKsgMSIqASfoJwiaik+KyQNJiEHUIiMzc5Py0vHSoRKYhpObIOVX19FWV9fTUlPT11FAn/8nJv2/LyMKWysjjiJFAAsoRncbGLWXGxj1JRUSh2o0pLY1EkTIOCDLWDgiyUAgMdoRK8YAmbmBgz3ZgYJyU5OQUlCXZOUQ5WJlSjZGRkUYLdrbDQ3riw0AtDQtPWVkPV1lYHQwKnUb4lJR7WJSXBaBJsCF/LyysiJQYcyQcAO+5kYyU4V48AAAAASUVORK5CYII="

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAAejAAAHowEwL7LFAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAhNQTFRF/////+OOoqKi68Ri8r9moqKi771j8sNr9NiW67pi8ch59dKY7rxl7sNv8sl87Ltk9tWZ7sZ47b5l9dWX9deX7r5l88t77bxl7b9o8MZ08sl58sl4pqakpaWk88t99Mx+pqak7r9o7bxl7bxk8Md78Ml978Nv7bxk8sl5uK+c8cl+1cKd8cuAwbag78Nw8sqB88+JsqeV78Fu8syE9tWY7sBt8ch7raqj78Jv8s6F8cZ18sp97r9p68+a7b1mnZiT9M6C9NST88t988+J9M+K779q88+Jd36O7bxl8cVz4siX886CpaWk89CN89KR89KR7b1m88t+7bxk8sl57bxk8cRx8cZ28sp7dHuO8MFr9c+G9dWW8MNw9dCG9c6D9daX9M6B7bxk7b1l8MRx9dCG9daYVWGAV2OBZ3CIbnaLcnqNkZSblZedpaWk7bxk7b1l7r1m7r9p7r9q78Br78Ft78Ju78Jv78Jw8MNw8MVz8MV18MV28MZ38MZ48cV08cZ18cd28cd58cd68ch78ch88cl98cp/8sp/8suC8syD8syE8s2G88p888t+88x/882A886H886I88+J88+K88+L89CL89CM89CN89GN9M6D9NGO9NGP9NKP9NKQ9NKR9NOR9NOT9NST9NSU9NWY9c+F9dCG9dGH9dKJ9dSU9dSV9dWV9dWW9dWX9daX9daY9tKK9tOLpkrbywAAAGZ0Uk5TAAkLDRQWHyYuNEpKTExQUlVZYmJlamxvc3mFjo+Rl5ygpKq6u7zFxsbIyMnJztDQ0NHR1NfY2Nrc3N3e3+Hh4ujo6urr7Ozt7e3u7u/v7/Dx8vT09/f5+fr6+vr7+/z8/f7+/v7+DD6ZIwAAAd1JREFUOMuFk1dDE1EUhI+9967Yu2vvvWFBDfaODQtiOStIFAGlKRqF0DQGoxGJCibrfvATfdgkJGaj8/rN3jv37ByRpAaNGDdlwqjJ44cPEBk4z6Oq6skZksSjF5zdvWgfAHc2TpqtceXE8dhjn26svE5Su7bow+LiB6oeh0+88uzcAQeFWy2A76vuFxXdU1UREZl+81FePtD+0qa9LkzkC7DubtIwp6/v6gkA33vnlM9PA8CehGHoyZKSDRDu6o8QswAOxw0LTXMnRMpDpOqtzdGLqioytaXFnwtWMI1T1QrLVVVkSUXFdjIVi4ChqjK40DTXYjW4eBzD3N7eHwUEqzJxg2WoqswvLT0IdjTTUBkyVFXWe71bcVXEueJyd/cOaCNrhtOmuYKI13Z5R9BQVTlfU7MGPrh83/bCUFU55fdvds/wK2Coqiw1zU0QzZ5hWXPzGXj9LhNHHcOM6upbBXxszOCd5amjdlHY5xhkb0/PfqArWwYZU1b2OBeep6f4HSLxu+OFCacP800dicLIsAtNTdsAYinj7Ij1V05m1tYeOQ68qnSg5esgtbQi0wrNvHywAzaN9d8I1Xem115k1u2f1w4B8NXZm78WR2Tk6ieXFv9j9f6/vNnX/w/R9fdIrfI3CAAAAABJRU5ErkJggg=="

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADnAAAA5wHwG1i1AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAcVQTFRF////AICASbaSOaqO/8ZVM7OZ/9Fd/89gQKaZ/9NkQKqf/9VgQKSb/9VmQqWc/9Ji/9Fi/9JgPqibQKicPKidPqec+tJk+tVh+9RjP6WdPaec+9RhQKacTq6Y/NZg/NVhPaaa/NRiPaeb/NRh/NVi/NViJ6Hb/dVjPqWaJ6LbPaab/dRhJ6PbPqWa/dViOqbP/dNh+9Rh+9VjJ6Hb+9Vi+9Rj+9Vh/NNiPqea/NNh/NRhPqabP6ab/NNi/NRjPqab/NRi/NRi/NRiP6ycP6yb/dNi/dRiPqabP6ubP6ic+9ViP6ucYLWS/NRiJ6Lb/NRiPqabPqecP6ycP6mcfLuKPqmb/NRiPaacgbyIPqWb/NViP6mcP6ydnL2Z/NRi/NRiPqabP6qcP6ucQLCdqsR7/NViHHWhHHaiH4OzIIa3I5LGJJTJJZvSJp/YJ6HaJ6LbPqabPqebP6qcP6ucP6ycP62cQK6dQK+dQLCdQLGdQLKdQLOdQbOeQbSeQbWeQbaeQbeeQrifQrmfQrqfQrufQryfQ72gQ76gQ8CgQ8GgRMKhRMOhRMShUMSdlMeElcODnr6Xqsl9q8t9q81+7NFn+9Ri/NRivrWKbwAAAGZ0Uk5TAAIHCQkKCxAUFxgYHB4fIicoKSwvMTM3O0FDR0hISk9TU1RZW2BibG9wcHF3d3h7e4OEiIqOkJKTmKCho6+wsra4xMfKzdHS0tjY2tzd4OXn6urr6+7v8fT19vf5+fn6+/z8/Pz8JijvNAAAAWBJREFUOMuF0GVXAkEUBuBRMbC7u7G7uxu7u3tXkRIQkHKWa6Lze13geIDdlX0/zvvM3HsGIU6iK7vHF1aW+qvikXCy6HsnPOqM+sOeFEGQqsCAaVr/oKA3QoVArArAonkBwKa1ZCEQrgQwWAHAZnVsFQqJbQClkwVOBpiDYgGwCE52ijfq/Ww+mAad8Q88z0fxwQhWORiTBbuBMldgxDBWYI3hTskAmDv4dULFDKO3m/U2qxbwZBi3jmzdI8smO9baNA4tHKVx+5hZQsi6mv0pWq15stby7o+xPTl+d7lcX59vrxMhnF4yRPzznec9rpnzpBxFDJDAFHlBM+VJff4UpydJAeCDW/+UoOCAjEpEACkQA+nBwW6TyA6rGWJLDoqBXhEgzwwO5FIk8kKnD9yeX1DUziYH9PnA9enZDSVD0tIuua8/yfcbcXlFscCdxJyyurb2lsaG6jjE2UGG/skvPEUnJJgzliUAAAAASUVORK5CYII="

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal_keypad__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modal_qrauthen__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modal_gate__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modal_keypadgate__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modal_memberauthen__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__service_services__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);













// var client = require('emitter-io').connect({
//   host: '35.240.146.79',
//   port: 8888
// })

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Keypad: __WEBPACK_IMPORTED_MODULE_3__components_modal_keypad__["a" /* default */],
    QRpad: __WEBPACK_IMPORTED_MODULE_4__components_modal_qrauthen__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay___default.a,
    Gate: __WEBPACK_IMPORTED_MODULE_5__components_modal_gate__["a" /* default */],
    keypadgate: __WEBPACK_IMPORTED_MODULE_6__components_modal_keypadgate__["a" /* default */],
    MemberPage: __WEBPACK_IMPORTED_MODULE_7__components_modal_memberauthen__["a" /* default */]
  },
  data: function data() {
    return {
      apiURL: sessionStorage.apiURL,
      set_mainpage: '',
      showstatus: false,
      timescreen: '',
      background: localStorage.background,
      logo_url: localStorage.logo_url,
      shop_title: localStorage.shop_title,
      lconfig: '',
      title: "เมนู",
      menu_active: 0,
      menu_data: [{
        menu_id: 3,
        menu_act: 0,
        image_name: "logo",
        image_path: __webpack_require__(201),
        goto: '',
        title_name: [{
          name_id: 0,
          name: "SCAN QRCODE"
        }, {
          name_id: 1,
          name: "สแกนคิวอาร์โค้ด"
        }, {
          name_id: 2,
          name: "入口"
        }]
      }, {
        menu_id: 2,
        menu_act: 1,
        image_name: "shopping",
        image_path: __webpack_require__(202),
        title_name: [{
          name_id: 0,
          name: "Shopping"
        }, {
          name_id: 1,
          name: "ซื้อสินค้า"
        }, {
          name_id: 2,
          name: "購物"
        }]
      }, {
        menu_id: 1,
        menu_act: 1,
        image_name: "economy",
        image_path: __webpack_require__(203),
        title_name: [{
          name_id: 0,
          name: "Deposit"
        }, {
          name_id: 1,
          name: "เติมเงิน"
        }, {
          name_id: 2,
          name: "存款"
        }]
        // {
        //   menu_id: 6,
        //   menu_act: 1,
        //   image_name: "logo",
        //   image_path: require("../assets/pay9.png"),
        //   goto: 'Openapp',
        //   title_name: [{
        //     name_id: 0,
        //     name: "Member Shop"
        //   },
        //   {
        //     name_id: 1,
        //     name: "สำหรับสมาชิก"
        //   },
        //   {
        //     name_id: 2,
        //     name: "對於會員"
        //   }
        //   ]
        // }
      }],
      items: [],
      countloop: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])(["lang", "UUID", "accessToken", "Mode", "Type", "AmountPayment", "AuthenType", "isconnect_emitterpay", "create_at", "shift_status", "mqttKey", "config", "ui_mode", "StatusHardware", "wsStatus"]), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(["onMessageWs", "clearState"])),
  methods: {
    screenServer: function screenServer() {
      var _this = this;

      this.timescreen = setTimeout(function () {
        _this.$router.push({ name: 'Screen' });
      }, 300000);
    },
    setMenu: function setMenu(value) {
      clearTimeout(this.timescreen);
      this.Soundclick();
      this.setTitle();
      this.$store.state.SaleID = value;
      this.$store.state.SaleType = 1;
      this.$store.state.acl = 0;
      if (value == 1) {
        this.$router.push({
          name: "WalletSigin"
        });
      } else if (value == 2) {
        this.$router.push({
          name: "shopping"
        });
      } else if (value == 3) {
        this.$store.state.AuthenType = 3;
        __WEBPACK_IMPORTED_MODULE_11_jquery___default()("#Modal").modal("show");
        return;
      } else if (value == 6) {
        this.$store.state.SaleID = 2;
        this.$store.state.AuthenType = 5;
        __WEBPACK_IMPORTED_MODULE_11_jquery___default()("#Modal").modal("show");
        return;
      }
      // else if (value == 7) {
      //   var testdata = "{\"note\":0, \"note2\":0, \"coin\":225}"
      //   var ret = JSON.parse(testdata.replace('"\"',''))
      //   var yuyu = {}
      //   yuyu.note = ret.note
      //   yuyu.note2 = ret.note2
      //   yuyu.coin = ret.coin
      //   console.log(yuyu)
      //   return
      // }
    },
    modeSwitch: function modeSwitch(mode) {
      __WEBPACK_IMPORTED_MODULE_10__service_services__["a" /* default */].switchMode(mode);
      if (mode == 1) {
        this.$store.state.ui_mode = 1;
      }
      if (mode == 0) {
        this.$store.state.ui_mode = 0;
      }
    },
    setLang: function setLang(value) {
      this.$store.state.lang = value;
      this.setTitle();
      this.getQuickPay();
    },
    setTitle: function setTitle() {
      switch (this.lang) {
        case 0:
          this.title = "Menu";
          break;
        case 1:
          this.title = "เมนู";
          break;
        case 2:
          this.title = "菜单";
      }
    },
    getUUID: function getUUID() {
      try {
        this.$socket.sendObj({
          command: "vending_uuid"
        });
        if (this.UUID != null) {}
      } catch (e) {
        // alert('cannot get UUID ERROR = ' + e);
        this.reload();
        // this.getUUID()
        // this.$store.state.isLoading = true;
        sessionStorage.clear();
      }
    },
    websocket_onmessage: function websocket_onmessage() {
      var _this2 = this;

      this.$socket.onmessage = function (skResult) {
        // this.$store.state.wsStatus = true
        _this2.$store.commit("onMessageWs", JSON.parse(skResult.data));
      };
    },
    getToken: function getToken() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_10__service_services__["a" /* default */].getToken({
        vending_uuid: this.UUID
        // vending_uuid: '6b12ab295135424bbf2dc9a4740685e0'
        // vending_uuid: '56819d086ae74798984b5b186a081234'
      }, function (result) {
        if (result.result == "success") {
          // อ่าจจะต้องเก็บไว้ใน session storage
          sessionStorage.accessToken = result.token;
          _this3.$store.state.accessToken = result.token;
          sessionStorage.mqttKey = result.mqtt_key;
          _this3.$store.state.mqttKey = result.mqtt_key;
          _this3.GetConfigSetting();
          if (_this3.$store.state.shift_uuid == "") {
            _this3.getShiftStatus();
          } else {
            // this.$store.state.isLoading = false;
          }
          _this3.CheckStatusPartner();
        } else {
          alert("get Token = " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result));
          sessionStorage.clear();
          _this3.getUUID();
        }
      }, function (error) {
        alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        sessionStorage.clear();
        _this3.getUUID();
      });
    },
    getShiftStatus: function getShiftStatus() {
      var _this4 = this;

      var header = {
        headers: {
          "x-access-token": this.$store.state.accessToken
        }
      };

      // this.$store.state.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_10__service_services__["a" /* default */].shitfStatus(header, function (result) {
        _this4.$store.state.shift_uuid = result.shift_uuid;
        _this4.$store.state.open_at = result.open_at;
        _this4.$store.state.shift_status = result.shift_status;
        // this.$store.state.isLoading = false;
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.fire({
          title: "Check Shift Status Error",
          text: error,
          type: "error",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Reconnect !"
        }).then(function (result) {
          if (result.value) {
            _this4.getShiftStatus();
          } else {
            _this4.getShiftStatus();
          }
        });
        // this.$store.state.isLoading = false;
      });
    },
    authen: function authen() {
      clearTimeout(this.timescreen);
      this.$store.state.AuthenType = 1;
      this.$socket.sendObj({
        Device: "host",
        type: "request",
        command: "qr"
      });
      __WEBPACK_IMPORTED_MODULE_11_jquery___default()("#Modal").modal("show");
    },
    close_qr: function close_qr() {
      this.$store.state.AuthenType = 0;
      // this.$socket.sendObj({
      //   Device: "host",
      //   type: "request",
      //   command: "qr_authentication"
      // });
    },
    getQuickPay: function getQuickPay() {
      var _this5 = this;

      // this.$store.state.isLoading = true
      var header = {
        headers: {
          "x-access-token": this.$store.state.accessToken
          // "x-access-token": '942be569a799418c9b4249dc964e7930'
        }
      };

      __WEBPACK_IMPORTED_MODULE_10__service_services__["a" /* default */].quick_pay(header, function (result) {
        _this5.$store.state.isLoading = false;

        if (result.result === 'success') {
          switch (_this5.lang) {
            case 0:
              if (result.data[1].items != null) {
                _this5.items = result.data[1].items;
              }
              break;
            case 1:
              if (result.data[0].items != null) {
                _this5.items = result.data[0].items;
              }
              break;
            case 2:
              if (result.data[2].items != null) {
                _this5.items = result.data[2].items;
              }
              break;
          }
        }
      }, function (error) {
        alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        // this.$store.state.isLoading = true
      });
    },
    message_received: function message_received(msg_pay) {
      var _this6 = this;

      var obj = {
        ref_number: msg_pay.ref_number,
        status: "MESSAGE_RECEIVED"
      };
      var header = {
        headers: {
          "x-access-token": this.$store.state.accessToken
          // "x-access-token": '942be569a799418c9b4249dc964e7930'
        }
      };

      __WEBPACK_IMPORTED_MODULE_10__service_services__["a" /* default */].getReceiveC9(obj, header, function (result) {
        if (_this6.$route.name == 'Main') {
          if (msg_pay.customer_code) {
            __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.fire({
              title: 'Payment id ' + msg_pay.customer_code,
              text: "รหัส: " + msg_pay.customer_name + ' ชื่อลูกค้า: ' + msg_pay.customer_name + ' ราคา: ' + msg_pay.amount + ' THB',
              type: 'warning',
              animation: true,
              showCancelButton: true,
              cancelButtonText: 'ยกเลิก',
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'ตกลง'
            }).then(function (result) {
              if (result.value) {
                _this6.$store.state.SaleID = 5;
                _this6.$store.state.SaleType = 1;
                _this6.$store.state.AmountPayment = 0;
                _this6.$store.state.total = msg_pay.amount;
                _this6.$store.state.ref_number = msg_pay.ref_number;
                _this6.$store.state.acl = 0;
                _this6.$store.state.sale_subs = [{
                  line: 1,
                  item_id: '1000589',
                  item_name: msg_pay.customer_name,
                  qty: 1,
                  price_id: 1,
                  price_name: '',
                  price: parseFloat(msg_pay.amount),
                  currency: "THB",
                  image: __webpack_require__(204)
                }];

                _this6.$router.push({
                  name: "Type"
                });
              } else {}
            });
          }
        }
      }, function (error) {
        alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    connect_emitter_payquick: function connect_emitter_payquick() {
      var _this7 = this;

      // this.$store.state.isLoading = true;
      if (this.$store.state.isconnect_emitterpay == 0) {
        try {
          this.$store.state.isconnect_emitterpay = 1;

          client.subscribe({
            // key: "vEmN6D_S7SaVKx6lTT1dAEJCNN__2U0c",
            // channel: "payment/2f570ceb279847a19fd570b9a6208852/"
            key: this.$store.state.mqttKey,
            channel: "payment/" + this.$store.state.accessToken + "/"
          });
          client.on('message', function (msg) {
            var msg_pay = msg.asObject();
            _this7.message_received(msg_pay);
          });
          this.$store.state.isLoading = false;
        } catch (e) {
          setTimeout(function () {
            location.reload();
          }, 3000);
        }
        // this.$store.state.isLoading = false;
      }
    },
    paymentQuickpay: function paymentQuickpay(obj) {
      this.$store.state.SaleID = 4;
      this.$store.state.SaleType = 1;
      this.$store.state.AmountPayment = 0;
      this.$store.state.total = obj.price;
      this.$store.state.acl = obj.acl;
      this.$store.state.sale_subs = [{
        line: 1,
        item_id: obj.id.toString(),
        item_name: obj.name,
        qty: 1,
        price_id: 1,
        price_name: obj.item_name,
        price: parseFloat(obj.price),
        currency: "THB",
        image: obj.image
      }];

      this.sayLang(obj.name);
      this.$router.push({
        name: "Type"
      });
    },
    stopinterval: function stopinterval() {
      clearInterval(this.$store.state.downloadTimer);
      clearInterval(this.$store.state.intervalqrcode);
    },
    GetConfigSetting: function GetConfigSetting() {
      var _this8 = this;

      var header = {
        headers: {
          "x-access-token": this.accessToken
          // "x-access-token": '942be569a799418c9b4249dc964e7930'
        }
      };
      __WEBPACK_IMPORTED_MODULE_10__service_services__["a" /* default */].configClient(header, function (result) {
        if (result.result == "success") {
          _this8.$store.state.config = result.client;
          // this.logo_url = localStorage.logo_url
          // this.shop_title = result.client.client.shop_title
          // this.background = localStorage.background
          localStorage.logo_url = result.client.client.logo_url;
          localStorage.shop_title = result.client.client.shop_title;
          localStorage.background = result.client.client.background;

          _this8.menu_data[0].menu_act = result.client.menu.door;
          _this8.menu_data[1].menu_act = result.client.menu.shopping;
          _this8.menu_data[2].menu_act = result.client.menu.deposit;
          _this8.menu_data[3].menu_act = result.client.menu.member;
        }
      }, function (error) {});
    },
    CheckStatusPartner: function CheckStatusPartner() {
      var _this9 = this;

      var header = {
        headers: {
          "x-access-token": this.accessToken
          // "x-access-token": '2f570ceb279847a19fd570b9a6208850'
        }
      };
      __WEBPACK_IMPORTED_MODULE_10__service_services__["a" /* default */].CheckStatusPartner(header, function (result) {
        if (result.response == "success") {} else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.fire({
            title: 'แจ้งเตือน',
            text: "ระบบมีปัญหากรุณาติดต่อเจ้าหน้าที่",
            type: "error",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            // cancelButtonColor: "#d33",
            confirmButtonText: "Reconnect !",
            timer: 30000
          }).then(function (result) {
            if (result.value) {
              _this9.$router.push({
                name: "Main"
              });
            }
            _this9.reload();
          });
        }
      }, function (error) {});
    }
  },
  created: function created() {
    // this.connect_ws()
    // this.screenServer()
    clearInterval(this.$store.state.scan_barcode);
    this.websocket_onmessage();
    this.$store.commit('clearState');
    __WEBPACK_IMPORTED_MODULE_10__service_services__["a" /* default */].switchMode(this.$store.state.ui_mode);
    this.getUUID();
  },
  mounted: function mounted() {
    var _this10 = this;

    this.set_mainpage = setInterval(function () {
      _this10.$store.state.isLoading = true;
      // this.getUUID();

      if (_this10.countloop == 5) {
        location.reload();
      }
      _this10.countloop++;
      if (_this10.UUID != '' && _this10.UUID != null) {
        _this10.$store.state.isLoading = false;
        clearInterval(_this10.set_mainpage);
        _this10.$socket.sendObj({
          Device: 'host',
          type: 'request',
          command: 'status'
        });
        if (!_this10.accessToken) {
          _this10.$store.state.isLoading = true;
        }

        clearInterval(_this10.$store.state.setInter);
        _this10.$store.commit('clearPulling');
        setTimeout(function () {
          _this10.getToken();
          __WEBPACK_IMPORTED_MODULE_11_jquery___default()("#Modal").on("hidden.bs.modal", function () {
            clearInterval(this.$store.state.downloadTimer);
            clearInterval(this.$store.state.intervalqrcode);
            clearInterval(this.$store.state.stepauthmember);
            // this.screenServer()
            this.close_qr();
          }.bind(_this10));
          __WEBPACK_IMPORTED_MODULE_11_jquery___default()("body").on("hidden.bs.modal", ".modal", function () {
            __WEBPACK_IMPORTED_MODULE_11_jquery___default()(this).removeData("bs.modal");
          });
          _this10.$store.state.IDWallet = null;
          _this10.setLang(1);
          _this10.$store.state.accessToken = sessionStorage.accessToken;

          // this.$store.state.mqttKey = sessionStorage.mqttKey;
          // console.log('mqttKey = ' + this.$store.state.mqttKey)
          // console.log('token = ' + this.$store.state.accessToken)
          setTimeout(function () {
            if (_this10.UUID != null) {
              if (!_this10.$store.state.accessToken || _this10.$store.state.accessToken === 'undefined') {
                _this10.getToken();
              } else {
                _this10.getShiftStatus();
                _this10.getQuickPay();
              }
            } else {
              _this10.getUUID();
            }
          }, 1000);
          // this.connect_emitter_payquick()
          _this10.setTitle();
          // this.lconfig = setInterval(() => {
          //   if (this.$store.state.accessToken || this.$store.state.accessToken != 'undefined') {
          //     console.log('tag')
          //     this.GetConfigSetting()
          //     clearInterval(this.lconfig)
          //   }
          // }, 1000);

          // console.clear()
          _this10.$store.state.setInter = setInterval(function () {
            _this10.checkWebsocket();
            if (_this10.UUID != null) {
              if (!_this10.$store.state.accessToken || _this10.$store.state.accessToken === 'undefined') {
                _this10.getToken();
              } else {
                _this10.getShiftStatus();
                _this10.CheckStatusPartner();
              }
            } else {
              _this10.getUUID();
            }
            _this10.checkCloseWebsocket();
          }, 30000);
        }, 2100);
      }
    }, 1000);
    // setTimeout(() => {
    //   this.$socket.sendObj({
    //     command: 'receive_close'
    //   })
    // }, 3000)
  }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__service_services__ = __webpack_require__(16);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      authen_qrcode: '',
      time: 0,
      step: '',
      Pass: "",
      timeleft: 0,
      downloadTimer: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])(["lang", "UUID", "accessToken", "Mode", "Type", "AmountPayment", "AuthenType", "isconnect_emitterpay", "StatusQrcode", "customerBalance"]), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(["onMessageWs"])),
  methods: {
    addKey: function addKey(int) {
      this.Soundclick();
      if (this.Pass.length < 6) {
        this.Pass += int.toString();
      }
    },
    removeKey: function removeKey() {
      this.Soundclick();
      var key = this.Pass;
      this.Pass = key.substring(key.length - 1, 0);
    },
    getAuthenPass: function getAuthenPass() {
      var _this = this;

      var header = {
        headers: {
          // "x-access-token": "4fa68bf1a9e042e6bef54de6542c2efa"
          "x-access-token": this.$store.state.accessToken
        }
      };
      __WEBPACK_IMPORTED_MODULE_7__service_services__["a" /* default */].authenQrcode(header, function (result) {
        _this.authen_qrcode = result.passcode;
        //this.authen_qrcode = '0987';
        _this.timeleft = result.remain_sec;
      }, function (error) {
        alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this.$store.state.isLoading = false;
      });
    },
    gotoSetting: function gotoSetting() {
      this.Soundclick();
      if (this.Pass === this.authen_qrcode) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#Modal').modal('hide');
        this.$router.push('/setting');

        this.timeleft = 0;
      } else {
        alert('Password ไม่ถูกต้อง');
        this.Pass = '';
      }
    },
    clickoutside: function clickoutside() {
      clearInterval(this.$store.state.downloadTimer);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.getAuthenPass();
    this.Pass = "";
    this.$store.state.downloadTimer = setInterval(function () {
      document.getElementById("countdown").innerHTML = _this2.timeleft + " seconds remaining";
      _this2.timeleft -= 1;
      if (_this2.timeleft <= 0) {
        _this2.getAuthenPass();
        document.getElementById("countdown").innerHTML = _this2.timeleft;
      }
      if (_this2.Pass == _this2.authen_qrcode) {
        clearInterval(_this2.$store.state.downloadTimer);
      }
    }, 1000);
  }
});

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAQAAACQ9RH5AAAACXBIWXMAAA3XAAAN1wFCKJt4AAADGGlDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjaY2BgnuDo4uTKJMDAUFBUUuQe5BgZERmlwH6egY2BmYGBgYGBITG5uMAxIMCHgYGBIS8/L5UBFTAyMHy7xsDIwMDAcFnX0cXJlYE0wJpcUFTCwMBwgIGBwSgltTiZgYHhCwMDQ3p5SUEJAwNjDAMDg0hSdkEJAwNjAQMDg0h2SJAzAwNjCwMDE09JakUJAwMDg3N+QWVRZnpGiYKhpaWlgmNKflKqQnBlcUlqbrGCZ15yflFBflFiSWoKAwMD1A4GBgYGXpf8EgX3xMw8BSMDVQYqg4jIKAUICxE+CDEESC4tKoMHJQODAIMCgwGDA0MAQyJDPcMChqMMbxjFGV0YSxlXMN5jEmMKYprAdIFZmDmSeSHzGxZLlg6WW6x6rK2s99gs2aaxfWMPZ9/NocTRxfGFM5HzApcj1xZuTe4FPFI8U3mFeCfxCfNN45fhXyygI7BD0FXwilCq0A/hXhEVkb2i4aJfxCaJG4lfkaiQlJM8JpUvLS19QqZMVl32llyfvIv8H4WtioVKekpvldeqFKiaqP5UO6jepRGqqaT5QeuA9iSdVF0rPUG9V/pHDBYY1hrFGNuayJsym740u2C+02KJ5QSrOutcmzjbQDtXe2sHY0cdJzVnJRcFV3k3BXdlD3VPXS8Tbxsfd99gvwT//ID6wIlBS4N3hVwMfRnOFCEXaRUVEV0RMzN2T9yDBLZE3aSw5IaUNak30zkyLDIzs+ZmX8xlz7PPryjYVPiuWLskq3RV2ZsK/cqSql01jLVedVPrHzbqNdU0n22VaytsP9op3VXUfbpXta+x/+5Em0mzJ/+dGj/t8AyNmf2zvs9JmHt6vvmCpYtEFrcu+bYsc/m9lSGrTq9xWbtvveWGbZtMNm/ZarJt+w6rnft3u+45uy9s/4ODOYd+Hmk/Jn58xUnrU+fOJJ/9dX7SRe1LR68kXv13fc5Nm1t379TfU75/4mHeY7En+59lvhB5efB1/lv5dxc+NH0y/fzq64Lv4T8Ffp360/rP8f9/AA0ADzT6lvFdAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAACoSURBVHja7JddDoAwCIMt8f5XrhfwB2bRRbu3JbAvZYVs4FJcRwmoHQPeRw7hQ4rNRqUVV+8DGsVlG2QyogGbyorlpRUtehOZ5+Ziyj4cMdk6oAU7eypLzYIKVMsdsg6F1lyVw6EBU9I1VCiGIGL+AfJnMIRRDyiGcmRKNNtcBhts8PicYc8D4HKiTVNqtpFoVxtssMEGG2ywwQYbbPBnwWgjzfJ32gYAN+kadB3tIpwAAAAASUVORK5CYII="

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__service_services__ = __webpack_require__(16);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      Time: 100,
      authen_qrcode: '',
      step_process: '',
      qr_base64: '',
      remain_sec: '',
      step: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])(["lang", "UUID", "accessToken", "Mode", "Type", "AmountPayment", "AuthenType", "isconnect_emitterpay", "StatusQrcode", "customerBalance"]), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(["onMessageWs"])),
  methods: {
    inputPassword: function inputPassword() {
      this.Soundclick();
      this.$store.state.AuthenType = 2;
      // this.$socket.sendObj({
      //   Device: "host",
      //   type: "request",
      //   command: "qr_reader_off"
      // });
    },
    getAuthenCode: function getAuthenCode() {
      var _this = this;

      var header = {
        headers: {
          //"x-access-token": "4fa68bf1a9e042e6bef54de6542c2efa"
          "x-access-token": this.$store.state.accessToken
        }
      };

      __WEBPACK_IMPORTED_MODULE_7__service_services__["a" /* default */].authenQrcode(header, function (result) {
        _this.authen_qrcode = result.passcode;
        _this.qr_base64 = result.qr_base64;
        _this.$store.state.StatusQrcode = '';
        //this.authen_qrcode = 'test';
      }, function (error) {
        alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this.$store.state.isLoading = false;
      });
    },
    websocket_onmessage: function websocket_onmessage() {
      var _this2 = this;

      this.$socket.onmessage = function (skResult) {
        var data = JSON.parse(skResult.data);
        if (data.command = "qr") {
          _this2.$store.state.StatusQrcode = data.data;
          try {
            //if (list.permission) {
            // console.log("StatusQrcode = ", this.$store.state.StatusQrcode)
            // console.log("authen_qrcode = ", this.authen_qrcode)
            if (_this2.authen_qrcode == _this2.$store.state.StatusQrcode) {
              __WEBPACK_IMPORTED_MODULE_3_jquery___default()("#Modal").modal("hide");
              // this.$socket.sendObj({
              //   Device: "host",
              //   type: "request",
              //   command: "qr_reader_off"
              // });
              _this2.authen_qrcode = '';
              _this2.$store.state.StatusQrcode = '';
              _this2.$router.push("/setting");
            } else {
              // this.getAuthenCode();
              // this.$store.state.StatusQrcode = '';
            }
          } catch (e) {}
        } else {
          _this2.$store.commit("onMessageWs", JSON.parse(skResult.data));
        }
      };
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$store.state.intervalqrcode = setInterval(function () {
      _this3.Time -= 1;
      _this3.getAuthenCode();
    }, 700);

    this.websocket_onmessage();
    // if (this.Time == 0) {
    //   clearInterval(times);
    // }
  }
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__service_services__ = __webpack_require__(16);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      step_process: "",
      Time: 0,
      response: "",
      member_id: "",
      member_code: "",
      rfid_code: "",
      qr_code: "",
      pin_code: "",
      member_name_th: "",
      member_last_name_th: "",
      balance: "",
      qr_code_test: "83"
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])(["lang", "UUID", "accessToken", "Mode", "Type", "AmountPayment", "AuthenType", "isconnect_emitterpay", "StatusQrcode", "customerBalance"]), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(["onMessageWs"])),
  methods: {
    // websocket_onmessage() {
    //   this.$socket.onmessage = skResult => {
    //     this.$store.commit("openGate", JSON.parse(skResult.data));
    //   };
    // },
    inputPassword: function inputPassword() {
      this.Soundclick();
      this.$store.state.AuthenType = 4;
    },
    openDoor: function openDoor() {
      var _this = this;

      this.$store.state.isLoading = true;
      var header = {
        headers: {
          "x-access-token": this.accessToken
        }
      };
      var body = { code: this.$store.state.StatusQrcode };
      __WEBPACK_IMPORTED_MODULE_7__service_services__["a" /* default */].checkBalance(body, header, function (result) {
        _this.$store.state.StatusQrcode = null;
        _this.$store.state.customerBalance = result;
        if (result.response === "valid") {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
            title: "แจ้งเตือน !",
            html: "<h2 style='color: #555;'> " + _this.customerBalance.member_name_th + "&nbsp;&nbsp;" + _this.customerBalance.member_last_name_th + " มียอดเงินคงเหลือ " + result.balance + " บาท </h2> <h2>ต้องการใช้สิทธิในการเปิดประตูใช่หรือไม่ ?</h2>",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes"
          }).then(function (result) {
            if (result.value) {
              _this.$socket.sendObj({
                command: "open_cash_box",
                data: 10
              });
            }
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default()("#Modal").modal("hide");
          _this.SoundFaild();
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
            title: "แจ้งเตือน ?",
            html: "<h3 style='color: #555;'>หมายเลขของท่าน ยังไม่ได้รับการลงทะเบียน กรุณาติดต่อเจ้าหน้าที่</h3>",
            type: "error"
          });
        }
        _this.$store.state.isLoading = false;
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()("#Modal").modal("hide");
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
          title: "แจ้งเตือน ?",
          html: "<h2 style='color: #555;'>หมายเลขของท่าน ยังไม่ได้รับการลงทะเบียน กรุณาติดต่อเจ้าหน้าที่</h2>",
          type: "error"
        });
        _this.$store.state.isLoading = false;
        alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.step_process = setInterval(function () {
      if (_this2.$store.state.StatusQrcode) {
        _this2.openDoor();
        clearInterval(_this2.step_process);
      }
    }, 1000);
    // setTimeout(() => {
    //   this.$store.state.StatusQrcode = "+660946358888";
    // }, 5000);
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__service_services__ = __webpack_require__(16);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      authen_qrcode: '',
      time: 0,
      step: '',
      Pass: "",
      timeleft: 0,
      step_process: "",
      Time: 0,
      response: ""
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])(["lang", "UUID", "accessToken", "Mode", "Type", "AmountPayment", "AuthenType", "isconnect_emitterpay", "StatusQrcode", "customerBalance"]), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(["onMessageWs"])),
  methods: {
    addKey: function addKey(int) {
      this.Soundclick();
      if (this.Pass.length < 10) {
        this.Pass += int.toString();
      }
    },
    removeKey: function removeKey() {
      this.Soundclick();
      var key = this.Pass;
      this.Pass = key.substring(key.length - 1, 0);
    },
    gotoSetting: function gotoSetting() {
      this.Soundclick();
      if (this.Pass === this.authen_qrcode) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#Modal').modal('hide');
        this.$router.push('/setting');

        this.timeleft = 0;
      } else {
        alert('Password ไม่ถูกต้อง');
        this.Pass = '';
      }
    },
    clickoutside: function clickoutside() {
      clearInterval(this.$store.state.downloadTimer);
    },
    openDoor: function openDoor() {
      var _this = this;

      this.$store.state.isLoading = true;
      var header = {
        headers: {
          "x-access-token": this.accessToken
        }
      };
      this.Pass = this.Pass.substring(1, this.Pass.length);
      this.Pass = '+66' + this.Pass;
      var body = { code: this.Pass };

      __WEBPACK_IMPORTED_MODULE_7__service_services__["a" /* default */].checkValidate(body, header, function (result) {
        if (result.response === "available") {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
            title: "แจ้งเตือน !",
            html: "<h2 style='color: #555;'> " + result.message + "<h2>ต้องการใช้สิทธิในการเปิดประตูใช่หรือไม่ ?</h2>",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes"
          }).then(function (result) {
            if (result.value) {
              _this.$socket.sendObj({
                command: "open_cash_box",
                data: 10
              });
              __WEBPACK_IMPORTED_MODULE_3_jquery___default()("#Modal").modal("hide");
            }
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default()("#Modal").modal("hide");
          _this.SoundFaild();
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
            title: "แจ้งเตือน ?",
            html: "<h3 style='color: #555;'>รหัสผ่านไม่ถูกต้อง</h3>",
            type: "error"
          });
        }
        _this.$store.state.isLoading = false;
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()("#Modal").modal("hide");
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
          title: "แจ้งเตือน ?",
          html: "<h2 style='color: #555;'>ระบบมีปัญหา กรุณาติดต่อเจ้าหน้าที่</h2>",
          type: "error"
        });
        _this.$store.state.isLoading = false;
        alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    }
  },
  mounted: function mounted() {
    this.Pass = "";
    // this.$store.state.downloadTimer = setInterval(()=>{
    //   document.getElementById("countdown").innerHTML = this.timeleft + " seconds remaining";
    //   this.timeleft -= 1;
    //   if(this.timeleft <= 0){
    //     this.getAuthenPass();
    //     document.getElementById("countdown").innerHTML = this.timeleft
    //   }
    //   if(this.Pass == this.authen_qrcode){
    //     clearInterval(this.$store.state.downloadTimer)
    //   }
    // }, 1000);
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__service_services__ = __webpack_require__(16);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      Time: 100,
      authen_qrcode: "",
      qr_base64: "",
      remain_sec: "",
      step: ""
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])(["lang", "UUID", "accessToken", "Mode", "Type", "AmountPayment", "AuthenType", "isconnect_emitterpay", "StatusQrcode", "customerBalance", "stepauthmember", "phone_member"]), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(["onMessageWs"])),
  created: function created() {
    this.$store.state.member_auth_fact = true;
    this.$barcodeScanner.init(this.onBarcodeScanned);
  },

  methods: {
    Cancel: function Cancel() {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()("#Modal").modal("hide");
    },
    validateID: function validateID(CodeID) {
      var _this = this;

      var header = {
        headers: {
          //"x-access-token": "4fa68bf1a9e042e6bef54de6542c2efa"
          "x-access-token": this.$store.state.accessToken
        }
      };

      var body = {
        // _compgrp: "commons",
        // _comp: "api",
        // _action: "validate",
        // vending_id: this.$store.state.UUID,
        code: CodeID
      };
      __WEBPACK_IMPORTED_MODULE_7__service_services__["a" /* default */].checkValidate(body, header, function (result) {
        _this.$store.state.StatusQrcode = '';
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()("#Modal").modal("hide");

        if (result.response == "available") {
          _this.$store.state.memberType = 1;
          _this.authen_qrcode = "";
          _this.$store.state.StatusQrcode = "";
          _this.$store.state.phone_member = "";
          _this.$router.push("/shopping");
        } else {
          var text = "";
          var title = "";
          var text2 = "";
          var title2 = "";
          var ButtonText = "";
          switch (_this.lang) {
            case 0:
              text = "Member code not found Please contact staff";
              title = "Notification";
              ButtonText = "Close";
              break;
            case 2:
              text = "找不到会员代码 请联系工作人员";
              title = "來自系統的通知";
              ButtonText = "";
              break;
            default:
              text = "ไม่พบรหัสสมาชิก กรุณาติดต่อเจ้าหน้าที่";
              title = "แจ้งเตือนจากระบบ";
              ButtonText = "ปิด";
              break;
          }
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
            text: text,
            title: title,
            type: 'error',
            timer: 10000,
            // type: "warning",
            // confirmButtonColor: "#3085d6",
            // cancelButtonColor: "#d33",
            confirmButtonText: ButtonText
          });
          // .then(result => {
          //   if (result.value) {
          //     this.$store.state.memberType = 0
          //     this.authen_qrcode = ""
          //     this.$store.state.StatusQrcode = ""
          //     this.$router.push("/shopping")
          //   }
          // })
        }
      }, function (error) {
        _this.$store.state.StatusQrcode = '';
        alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this.$store.state.isLoading = false;
      });
    },
    CheckMemberC9: function CheckMemberC9(CodeID) {
      var _this2 = this;

      //test
      var header = {
        headers: {
          // "X-Access-Token": "12c1840ca3664dd799db80ce5f6a5b21"
          // "X-Access-Token": "5725a8c515594fcc81561169ba753087"
          "x-access-token": this.$store.state.accessToken
        }
        //product
      };var body = {
        code: CodeID
      };

      __WEBPACK_IMPORTED_MODULE_7__service_services__["a" /* default */].checkValidate(body, header, function (result) {
        _this2.$store.state.StatusQrcode = '';
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()("#Modal").modal("hide");

        if (result.response == "available") {
          _this2.$store.state.memberType = 1;
          _this2.authen_qrcode = "";
          _this2.$store.state.StatusQrcode = "";
          _this2.$store.state.memberProfile = result.data;

          _this2.$store.state.flag_member = 1, _this2.$router.push("/shopping");
        } else {
          var text = "";
          var title = "";
          var text2 = "";
          var title2 = "";
          var ButtonText = "";
          switch (_this2.lang) {
            case 0:
              text = "Member code not found Please contact staff";
              title = "Notification";
              ButtonText = "Close";
              break;
            case 2:
              text = "找不到会员代码 请联系工作人员";
              title = "來自系統的通知";
              ButtonText = "";
              break;
            default:
              text = "ไม่พบรหัสสมาชิก กรุณาติดต่อเจ้าหน้าที่";
              title = "แจ้งเตือนจากระบบ";
              ButtonText = "ปิด";
              break;
          }
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
            text: text,
            title: title,
            type: 'error',
            timer: 10000,
            confirmButtonText: ButtonText
          });
        }
      }, function (error) {
        _this2.$store.state.StatusQrcode = '';
        alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this2.$store.state.isLoading = false;
      });
    },
    onBarcodeScanned: function onBarcodeScanned(barcode) {
      this.authMember(barcode);
    },
    authMember: function authMember(barcode) {
      if (barcode) {
        if (barcode == "memberpass1111") {
          barcode = '';
          __WEBPACK_IMPORTED_MODULE_3_jquery___default()("#Modal").modal("hide");
          this.$store.state.memberType = 1;
          this.authen_qrcode = "";
          this.$router.push("/shopping");
        } else {
          this.CheckMemberC9(barcode);
        }
      }
    },
    websocket_onmessage: function websocket_onmessage() {
      var _this3 = this;

      this.$socket.onmessage = function (skResult) {
        var data = JSON.parse(skResult.data);
        if (data.command = "qr") {
          if (_this3.$store.state.member_auth_fact == true) {
            _this3.authMember(data.data);
          }
        }
        _this3.$store.commit("onMessageWs", JSON.parse(skResult.data));
      };
    }
  },
  mounted: function mounted() {
    // this.$store.state.StatusQrcode = "+66613351889"
    // this.websocket_onmessage()
    // setTimeout(() => {
    //   this.validateID("+666133456451889")
    // }, 3000)
    this.websocket_onmessage();
    // this.$store.state.stepauthmember = setInterval(() => {
    //   console.log("log")
    //   if (this.$store.state.StatusQrcode) {
    //     console.log("log")
    //     if (this.$store.state.StatusQrcode == "memberpass1111") {
    //       this.$store.state.StatusQrcode = ''
    //       $("#Modal").modal("hide")
    //       this.$store.state.memberType = 1
    //       this.authen_qrcode = ""
    //       this.$router.push("/shopping")
    //       clearInterval(this.$store.state.stepauthmember)
    //     console.log(this.$store.state.StatusQrcode)
    //     } else {
    //     console.log(this.$store.state.StatusQrcode)
    //     // this.validateID(this.$store.state.StatusQrcode)
    //     this.CheckMemberC9(this.$store.state.StatusQrcode)
    //     clearInterval(this.$store.state.stepauthmember)
    //     }
    //   }
    // }, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.state.member_auth_fact = false;
    this.$barcodeScanner.destroy();
  }
});

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(186);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(64)("f1bb70ac", content, true, {});

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(true);
// imports


// module
exports.push([module.i, ".menu,.no-quickpay h1{color:#000!important}#Modal{overflow:hidden}.mini-status{border:1px solid #555;width:15px;height:15px;margin-top:3px}.green-true{background:#04f904}.red-true{background:red}.green-false{background:#3a6330}.red-false{background:#b54141}", "", {"version":3,"sources":["C:/Users/imkeeper/Desktop/Paybox/ui/C9/src/components/Main.vue"],"names":[],"mappings":"AACA,sBACI,oBAAsB,CACzB,AACD,OACI,eAAiB,CACpB,AACD,aACE,sBAAuB,AACvB,WAAY,AACZ,YAAa,AACb,cAAgB,CACjB,AACD,YACE,kBAAoB,CACrB,AACD,UACE,cAAoB,CACrB,AACD,aACE,kBAAoB,CACrB,AACD,WACE,kBAAoB,CACrB","file":"Main.vue","sourcesContent":["\n.menu, .no-quickpay h1 {\r\n    color: #000!important;\n}\n#Modal {\r\n    overflow: hidden;\n}\n.mini-status {\r\n  border: 1px solid #555;\r\n  width: 15px;\r\n  height: 15px;\r\n  margin-top: 3px;\n}\n.green-true {\r\n  background: #04f904;\n}\n.red-true {\r\n  background: #ff0000;\n}\n.green-false {\r\n  background: #3a6330;\n}\n.red-false {\r\n  background: #b54141;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_keypad_vue__ = __webpack_require__(151);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_724c7f93_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_keypad_vue__ = __webpack_require__(190);
function injectStyle (ssrContext) {
  __webpack_require__(188)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_keypad_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_724c7f93_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_keypad_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(189);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(64)("193c5508", content, true, {});

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(true);
// imports


// module
exports.push([module.i, ".bt-setting{width:30%;height:90px;margin:1%;font-size:100px;font-weight:700;line-height:30px;text-align:center;overflow:hidden}.bt-setting span{line-height:30px;margin:0;padding:0}.setting_input{width:95%;margin-left:2.5%;height:80px;padding-top:20px;margin-right:10px;border:0;font-size:198px;line-height:300px;text-align:right;-webkit-text-security:disc;overflow:hidden;margin-bottom:0;text-align:center}", "", {"version":3,"sources":["C:/Users/imkeeper/Desktop/Paybox/ui/C9/src/components/modal/keypad.vue"],"names":[],"mappings":"AACA,YACE,UAAW,AACX,YAAa,AACb,UAAoB,AACpB,gBAAiB,AACjB,gBAAkB,AAClB,iBAAkB,AAClB,kBAAmB,AACnB,eAAiB,CAClB,AACD,iBACE,iBAAkB,AAClB,SAAU,AACV,SAAW,CACZ,AACD,eACE,UAAW,AACX,iBAAkB,AAClB,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,SAAY,AACZ,gBAAiB,AACjB,kBAAmB,AACnB,iBAAkB,AAClB,2BAA4B,AAC5B,gBAAiB,AACjB,gBAAmB,AACnB,iBAAmB,CACpB","file":"keypad.vue","sourcesContent":["\n.bt-setting {\r\n  width: 30%;\r\n  height: 90px;\r\n  margin: 1% 1% 1% 1%;\r\n  font-size: 100px;\r\n  font-weight: bold;\r\n  line-height: 30px;\r\n  text-align: center;\r\n  overflow: hidden;\n}\n.bt-setting span {\r\n  line-height: 30px;\r\n  margin: 0;\r\n  padding: 0;\n}\n.setting_input {\r\n  width: 95%;\r\n  margin-left: 2.5%;\r\n  height: 80px;\r\n  padding-top: 20px;\r\n  margin-right: 10px;\r\n  border: 0px;\r\n  font-size: 198px;\r\n  line-height: 300px;\r\n  text-align: right;\r\n  -webkit-text-security: disc;\r\n  overflow: hidden;\r\n  margin-bottom: 0px;\r\n  text-align: center;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"40px","padding-left":"0px"}},[_c('i',{staticStyle:{"position":"absolute","left":"30px","top":"25px","font-size":"24px"}},[_vm._v("Enter password....")]),_vm._v(" "),_c('div',{staticStyle:{"width":"95%","margin-left":"2.5%","height":"80px","border":"1px solid gray","border-radius":"9px","overflow":"hidden"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Pass),expression:"Pass"}],staticClass:"setting_input",attrs:{"type":"text","readonly":"true","max":"6"},domProps:{"value":(_vm.Pass)},on:{"input":function($event){if($event.target.composing){ return; }_vm.Pass=$event.target.value}}})]),_vm._v(" "),_c('div',{attrs:{"id":"countdown"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary bt-setting",on:{"click":function($event){_vm.addKey(1)}}},[_vm._v("1")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary bt-setting",on:{"click":function($event){_vm.addKey(2)}}},[_vm._v("2")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary bt-setting",on:{"click":function($event){_vm.addKey(3)}}},[_vm._v("3")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary bt-setting",on:{"click":function($event){_vm.addKey(4)}}},[_vm._v("4")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary bt-setting",on:{"click":function($event){_vm.addKey(5)}}},[_vm._v("5")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary bt-setting",on:{"click":function($event){_vm.addKey(6)}}},[_vm._v("6")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary bt-setting",on:{"click":function($event){_vm.addKey(7)}}},[_vm._v("7")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary bt-setting",on:{"click":function($event){_vm.addKey(8)}}},[_vm._v("8")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary bt-setting",on:{"click":function($event){_vm.addKey(9)}}},[_vm._v("9")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary bt-setting",on:{"click":function($event){_vm.addKey(0)}}},[_vm._v("0")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger bt-setting",on:{"click":_vm.removeKey}},[_c('img',{attrs:{"src":__webpack_require__(134)}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-success bt-setting",on:{"click":_vm.gotoSetting}},[_c('img',{attrs:{"src":__webpack_require__(152)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qrauthen_vue__ = __webpack_require__(153);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b45d31e4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_qrauthen_vue__ = __webpack_require__(192);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qrauthen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b45d31e4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_qrauthen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"40px","padding-left":"0px"}},[_c('b',{staticStyle:{"font-size":"700px","line-height":"500px"}}),_vm._v(" "),_c('div',{attrs:{"id":"QRA"}},[_c('h1',[_vm._v("Scan QR CODE")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(135),"width":"400"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-lg",staticStyle:{"font-size":"40px"},attrs:{"type":"button"},on:{"click":_vm.inputPassword}},[(_vm.$store.state.lang == 0)?_c('b',[_vm._v("Use Password")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 1)?_c('b',[_vm._v("ใช้แบบกรอกรหัส")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 2)?_c('b',[_vm._v("輸入密碼")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gate_vue__ = __webpack_require__(154);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af2ec324_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gate_vue__ = __webpack_require__(194);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af2ec324_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"40px","padding-left":"0px"}},[_c('div',{attrs:{"id":"QRA"}},[_c('img',{attrs:{"src":__webpack_require__(135),"width":"400"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h1',{staticStyle:{"color":"#000"}},[_vm._v("Scan QR CODE สำหรับ ทางเข้า")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-lg",staticStyle:{"font-size":"40px"},attrs:{"type":"button"},on:{"click":_vm.inputPassword}},[(_vm.$store.state.lang == 0)?_c('b',[_vm._v("Use Password")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 1)?_c('b',[_vm._v("ใช้แบบกรอกรหัส")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 2)?_c('b',[_vm._v("輸入密碼")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_keypadgate_vue__ = __webpack_require__(155);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_644fc19c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_keypadgate_vue__ = __webpack_require__(198);
function injectStyle (ssrContext) {
  __webpack_require__(196)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_keypadgate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_644fc19c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_keypadgate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(197);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(64)("7b26b35a", content, true, {});

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(true);
// imports


// module
exports.push([module.i, ".bt-setting{width:30%;height:90px;margin:1%;font-size:100px;font-weight:700;line-height:30px;text-align:center;overflow:hidden}.bt-setting span{line-height:30px;margin:0;padding:0}.setting_input{width:95%;margin-left:2.5%;height:80px;padding-top:20px;margin-right:10px;border:0;font-size:198px;line-height:300px;text-align:right;-webkit-text-security:disc;overflow:hidden;margin-bottom:0;text-align:center}", "", {"version":3,"sources":["C:/Users/imkeeper/Desktop/Paybox/ui/C9/src/components/modal/keypadgate.vue"],"names":[],"mappings":"AACA,YACE,UAAW,AACX,YAAa,AACb,UAAoB,AACpB,gBAAiB,AACjB,gBAAkB,AAClB,iBAAkB,AAClB,kBAAmB,AACnB,eAAiB,CAClB,AACD,iBACE,iBAAkB,AAClB,SAAU,AACV,SAAW,CACZ,AACD,eACE,UAAW,AACX,iBAAkB,AAClB,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,SAAY,AACZ,gBAAiB,AACjB,kBAAmB,AACnB,iBAAkB,AAClB,2BAA4B,AAC5B,gBAAiB,AACjB,gBAAmB,AACnB,iBAAmB,CACpB","file":"keypadgate.vue","sourcesContent":["\n.bt-setting {\r\n  width: 30%;\r\n  height: 90px;\r\n  margin: 1% 1% 1% 1%;\r\n  font-size: 100px;\r\n  font-weight: bold;\r\n  line-height: 30px;\r\n  text-align: center;\r\n  overflow: hidden;\n}\n.bt-setting span {\r\n  line-height: 30px;\r\n  margin: 0;\r\n  padding: 0;\n}\n.setting_input {\r\n  width: 95%;\r\n  margin-left: 2.5%;\r\n  height: 80px;\r\n  padding-top: 20px;\r\n  margin-right: 10px;\r\n  border: 0px;\r\n  font-size: 198px;\r\n  line-height: 300px;\r\n  text-align: right;\r\n  -webkit-text-security: disc;\r\n  overflow: hidden;\r\n  margin-bottom: 0px;\r\n  text-align: center;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"40px","padding-left":"0px"}},[_c('i',{staticStyle:{"position":"absolute","left":"30px","top":"25px","font-size":"24px"}},[_vm._v("Enter password....")]),_vm._v(" "),_c('div',{staticStyle:{"width":"95%","margin-left":"2.5%","height":"80px","border":"1px solid gray","border-radius":"9px","overflow":"hidden"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Pass),expression:"Pass"}],staticClass:"setting_input",attrs:{"type":"text","readonly":"true","max":"6"},domProps:{"value":(_vm.Pass)},on:{"input":function($event){if($event.target.composing){ return; }_vm.Pass=$event.target.value}}})]),_vm._v(" "),_c('div',{attrs:{"id":"countdown"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary bt-setting",on:{"click":function($event){_vm.addKey(1)}}},[_vm._v("1")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary bt-setting",on:{"click":function($event){_vm.addKey(2)}}},[_vm._v("2")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary bt-setting",on:{"click":function($event){_vm.addKey(3)}}},[_vm._v("3")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary bt-setting",on:{"click":function($event){_vm.addKey(4)}}},[_vm._v("4")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary bt-setting",on:{"click":function($event){_vm.addKey(5)}}},[_vm._v("5")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary bt-setting",on:{"click":function($event){_vm.addKey(6)}}},[_vm._v("6")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary bt-setting",on:{"click":function($event){_vm.addKey(7)}}},[_vm._v("7")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary bt-setting",on:{"click":function($event){_vm.addKey(8)}}},[_vm._v("8")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary bt-setting",on:{"click":function($event){_vm.addKey(9)}}},[_vm._v("9")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary bt-setting",on:{"click":function($event){_vm.addKey(0)}}},[_vm._v("0")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger bt-setting",on:{"click":_vm.removeKey}},[_c('img',{attrs:{"src":__webpack_require__(134)}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-success bt-setting",on:{"click":function($event){_vm.openDoor()}}},[_c('img',{attrs:{"src":__webpack_require__(152)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_memberauthen_vue__ = __webpack_require__(156);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e837f2e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_memberauthen_vue__ = __webpack_require__(200);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_memberauthen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e837f2e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_memberauthen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"40px","padding-left":"0px"}},[_c('b',{staticStyle:{"font-size":"500px","line-height":"500px"}}),_vm._v(" "),_c('div',{attrs:{"id":"QRA"}},[_c('h2',{staticStyle:{"color":"var(--dark)"}},[_vm._v("Scan QR CODE Member ID")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(135),"width":"400"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-lg",staticStyle:{"font-size":"40px"},attrs:{"type":"button"},on:{"click":_vm.Cancel}},[(_vm.$store.state.lang == 0)?_c('b',[_vm._v("Cancel")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 1)?_c('b',[_vm._v("ยกเลิก")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 2)?_c('b',[_vm._v("取消")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shopping.0e8f289.png";

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/select_c9.740ac1c.png";

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",staticStyle:{"max-height":"600"},style:({ 'background-image': 'url('+ (_vm.background) + ')' })},[_c('div',{staticClass:"d-flex flex-wrap justify-content-between logo"},[_c('div',{directives:[{name:"touch",rawName:"v-touch:hold.prevenDefualt",value:(_vm.authen),expression:"authen",arg:"hold",modifiers:{"prevenDefualt":true}}],staticClass:"d-flex align-items-center",staticStyle:{"width":"30%","height":"100%"}},[_c('div',{staticStyle:{"overflow":"hidden","border-radius":"50%","background":"white","width":"100px","height":"100px","position":"relative"}},[_c('img',{staticStyle:{"position":"absolute","top":"50%","left":"50%","transform":"translate(-50%,-50%)"},attrs:{"src":_vm.logo_url,"alt":"paybox","width":"100","height":"100"}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center",staticStyle:{"width":"70%","height":"100%"}},[_c('div',{staticStyle:{"font-size":"40px","color":"white"}},[_vm._v(_vm._s(_vm.shop_title))])])]),_vm._v(" "),_c('div',{staticClass:"flex-wrap align-items-center justify-contentcontent"},[(_vm.apiURL=='https://staging.paybox.work')?_c('span',{staticStyle:{"color":"white","font-size":"30px","background-color":"red"}},[_vm._v("Staging Mode")]):_vm._e(),_vm._v(" "),(_vm.apiURL=='https://test.paybox.work')?_c('span',{staticStyle:{"color":"white","font-size":"30px","background-color":"red"}},[_vm._v("Test Mode")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap align-items-center justify-content-between lang-area"},[(_vm.lang == 0)?_c('span',{directives:[{name:"touch",rawName:"v-touch:hold.prevenDefualt",value:(_vm.reload),expression:"reload",arg:"hold",modifiers:{"prevenDefualt":true}}],staticClass:"badge badge-dark",staticStyle:{"font-size":"30px","font-weight":"bold"}},[_vm._v("EN")]):_vm._e(),_vm._v(" "),(_vm.lang == 1)?_c('span',{directives:[{name:"touch",rawName:"v-touch:hold.prevenDefualt",value:(_vm.reload),expression:"reload",arg:"hold",modifiers:{"prevenDefualt":true}}],staticClass:"badge badge-dark",staticStyle:{"font-size":"30px","font-weight":"bold"}},[_vm._v("TH")]):_vm._e(),_vm._v(" "),(_vm.lang == 2)?_c('span',{directives:[{name:"touch",rawName:"v-touch:hold.prevenDefualt",value:(_vm.reload),expression:"reload",arg:"hold",modifiers:{"prevenDefualt":true}}],staticClass:"badge badge-dark",staticStyle:{"font-size":"30px","font-weight":"bold"}},[_vm._v("CH")]):_vm._e(),_vm._v(" "),_c('img',{class:{ 'lang-active': _vm.lang == 0 },attrs:{"src":__webpack_require__(206),"alt":"china","width":"60","height":"60"},on:{"click":function($event){_vm.setLang(0); _vm.sayLang('English language')}}}),_vm._v(" "),_c('img',{class:{ 'lang-active': _vm.lang == 1 },attrs:{"src":__webpack_require__(207),"alt":"china","width":"60","height":"60"},on:{"click":function($event){_vm.setLang(1); _vm.sayLang('ภาษาไทย')}}}),_vm._v(" "),_c('img',{class:{ 'lang-active': _vm.lang == 2 },attrs:{"src":__webpack_require__(208),"alt":"china","width":"60","height":"60"},on:{"click":function($event){_vm.setLang(2); _vm.sayLang('中國')}}})]),_vm._v(" "),_c('h1',{staticStyle:{"font-size":"80px","margin-top":"30px","line-height":"70px","color":"white"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"container d-flex align-items-center justify-content-center",staticStyle:{"height":"auto"}},_vm._l((_vm.menu_data),function(m,k){return (m.menu_act==1)?_c('div',{key:k,staticClass:"d-flex align-items-center justify-content-center",class:{ 'menu': _vm.items.length > 0, 'no-quickpay': _vm.items.length < 1 }},_vm._l((m.title_name),function(t,i){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.lang == t.name_id),expression:"lang == t.name_id"}],key:i,staticStyle:{"width":"100%","height":"100%","padding-top":"15px"},on:{"click":function($event){_vm.setMenu(m.menu_id); _vm.sayLang(t.name);}}},[_c('img',{attrs:{"src":m.image_path,"alt":m.image_name,"width":"60%"}}),_vm._v(" "),_c('hr',{staticStyle:{"padding":"0px"}}),_vm._v(" "),_c('h3',{staticStyle:{"color":"#000"}},[_vm._v(_vm._s(t.name))])])}),0):_vm._e()}),0),_vm._v(" "),_c('div',{staticClass:"container d-flex align-items-center justify-content-center",staticStyle:{"height":"155px"}},_vm._l((_vm.items),function(item,k){return _c('div',{key:k,staticClass:"item d-flex align-items-center justify-content-center",style:({ backgroundImage: 'url(' + item.image + ')' }),on:{"click":function($event){_vm.paymentQuickpay(item)}}},[_c('h4',{staticClass:"item-name"},[_vm._v(_vm._s(item.name)),_c('br'),_vm._v(_vm._s(_vm.money_format(item.price))+" ฿")])])}),0),_vm._v(" "),_c('loading',{attrs:{"active":_vm.$store.state.isLoading,"can-cancel":false,"is-full-page":true},on:{"update:active":function($event){_vm.$set(_vm.$store.state, "isLoading", $event)}}}),_vm._v(" "),_c('div',{staticClass:"modal fade bd-example-modal-lg",attrs:{"id":"Modal","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalCenterTitle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"padding-left":"0px"}},[_c('div',{staticClass:"modal-body",staticStyle:{"height":"auto"}},[_c('button',{staticClass:"close",staticStyle:{"position":"absolute","top":"-20px","right":"5px"},attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.stopinterval()}}},[_c('span',{staticStyle:{"font-size":"100px"},attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),(_vm.$store.state.AuthenType == 1)?_c('QRpad'):_vm._e(),_vm._v(" "),(_vm.$store.state.AuthenType == 2)?_c('Keypad'):_vm._e(),_vm._v(" "),(_vm.$store.state.AuthenType == 3)?_c('Gate'):_vm._e(),_vm._v(" "),(_vm.$store.state.AuthenType == 4)?_c('keypadgate'):_vm._e(),_vm._v(" "),(_vm.$store.state.AuthenType == 5)?_c('MemberPage'):_vm._e()],1)])])]),_vm._v(" "),(_vm.showstatus == false)?_c('div',{staticClass:"row",staticStyle:{"margin-left":"-30px"}},[_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"card",staticStyle:{"border-radius":"0px"}},[_c('div',{staticClass:"card-body",staticStyle:{"padding":"3px 1px 0px 1px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center",on:{"click":function($event){_vm.showstatus = true}}},[_c('span',[_vm._v("status : ")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col text-center d-flex justify-content-around"},[_c('div',{staticClass:"mini-status",class:{ 'green-true': _vm.wsStatus == true, 'red-true': _vm.wsStatus == false }})])])])])])]):_vm._e(),_vm._v(" "),(_vm.showstatus == true)?_c('div',{staticClass:"row",staticStyle:{"margin-left":"-30px"}},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card",staticStyle:{"border-radius":"0px"}},[_c('div',{staticClass:"card-body",staticStyle:{"padding":"3px 1px 0px 1px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center",on:{"click":function($event){_vm.showstatus = false}}},[_c('span',[_vm._v("status : ")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-1 text-center d-flex justify-content-around"},[_c('div',{staticClass:"mini-status",class:{ 'green-true': _vm.wsStatus == true, 'red-true': _vm.wsStatus == false }})]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-1 text-center d-flex justify-content-around"},[_c('div',{staticClass:"mini-status",class:{ 'green-true': _vm.StatusHardware.edc == 'Terminal ready', 'red-true': _vm.StatusHardware.edc == 'Terminal not ready' }})]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-1 text-center d-flex justify-content-around"},[_c('div',{staticClass:"mini-status",class:{ 'green-true': _vm.$store.state.StatusHardware.ca == 'OK', 'red-true': _vm.StatusHardware.ca == 'Offline' }})]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-1 text-center d-flex justify-content-around"},[_c('div',{staticClass:"mini-status",class:{ 'green-true': _vm.StatusHardware.ba == 'OK' || _vm.StatusHardware.ba == 'Fault on note validation sensor', 'red-true': _vm.StatusHardware.ba == 'Offline' }})]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-1 text-center d-flex justify-content-around"},[_c('div',{staticClass:"mini-status",class:{ 'green-true': _vm.StatusHardware.qr == 'Busy', 'red-true': _vm.StatusHardware.qr == 'Offline' }})])])])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col text-center"},[_c('img',{attrs:{"src":__webpack_require__(139),"width":"18"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-1 text-center"},[_c('img',{attrs:{"src":__webpack_require__(139),"width":"18"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-1 text-center"},[_c('img',{attrs:{"src":__webpack_require__(141),"width":"18"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-1 text-center"},[_c('img',{attrs:{"src":__webpack_require__(142),"width":"18"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-1 text-center"},[_c('img',{attrs:{"src":__webpack_require__(143),"width":"18"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-1 text-center"},[_c('img',{attrs:{"src":__webpack_require__(144),"width":"18"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/uk-flag.a3fc321.png";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/thaiflag.a7a86e4.png";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/China.3a20a83.png";

/***/ })
]));


// WEBPACK FOOTER //
// static/js/0.2da4bbfb47133a350d9c.js